import { normaliseEmail } from '../../helpers';

/**
 * The link a referral recipient follows into the referral portal. It carries
 * the address the referral was sent to as a `login_hint`, so the portal can
 * pre-fill sign-in and tell a recipient who signed in with another address
 * why the referral will not open. The hint is a convenience only: Firestore
 * rules still decide who can read the referral.
 */
export class ReferralPortalLink {
  static readonly loginHintParam = 'login_hint';

  static build(
    portalUrl: string,
    referralUid: string,
    recipientEmail: string
  ): string {
    const link = new URL(`/referrals/${referralUid}`, portalUrl);
    link.searchParams.set(
      ReferralPortalLink.loginHintParam,
      normaliseEmail(recipientEmail)
    );
    return link.toString();
  }

  static loginHint(pathOrUrl: string): string | undefined {
    const link = new URL(pathOrUrl, 'https://placeholder.invalid');
    const hint = link.searchParams.get(ReferralPortalLink.loginHintParam);
    return hint ? normaliseEmail(hint) : undefined;
  }

  static isDifferentEmail(
    expectedEmail: string,
    signedInEmail: string
  ): boolean {
    return normaliseEmail(expectedEmail) !== normaliseEmail(signedInEmail);
  }
}
